import {Directive, Input, OnChanges, SimpleChanges} from '@angular/core';
import {NG_VALIDATORS, UntypedFormControl, Validator} from '@angular/forms';

@Directive({    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[cmnMax][formControlName],[cmnMax][formControl],[cmnMax][ngModel]',
    providers: [{provide: NG_VALIDATORS, useExisting: CmnMaxDirective, multi: true}]
})
export class CmnMaxDirective implements Validator, OnChanges {
    @Input()
    cmnMax: number;
    private _onChange: () => void;

  registerOnValidatorChange(fn: () => void): void {
    this._onChange = fn;
  }

  validate(c: UntypedFormControl): {[key: string]: any} {
    return ( +c.value > +this.cmnMax) ? {'cmnMax': true} : null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('cmnMax' in changes) {
      if (this._onChange) {
        this._onChange();
      }
    }
  }
}
